import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cyber-dark px-4">
      <div className="text-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-9xl font-bold font-orbitron text-cyber-pink animate-glitch">
            404
          </h1>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h2 className="text-3xl md:text-4xl font-orbitron font-bold mt-4 mb-6 text-white">
            <span className="text-cyber-neon">System</span> Error: Page Not Found
          </h2>
          
          <p className="text-gray-300 max-w-md mx-auto mb-8">
            The digital pathway you requested has been corrupted or no longer exists in our network.
          </p>
          
          <div className="cyber-card inline-block p-[2px] bg-gradient-to-r from-cyber-pink via-cyber-purple to-cyber-neon">
            <Link 
              to="/" 
              className="block px-8 py-3 bg-cyber-dark hover:bg-cyber-gray transition-colors duration-300"
            >
              <span className="font-orbitron text-white">Return to Base</span>
            </Link>
          </div>
        </motion.div>
      </div>
      
      {/* Background animated glitch lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(10)].map((_, i) => (
          <div 
            key={i}
            className="absolute h-[1px] bg-cyber-pink opacity-30"
            style={{
              left: 0,
              right: 0,
              top: `${i * 10 + Math.random() * 5}%`,
              transform: `scaleX(${Math.random()})`,
              filter: 'blur(1px)',
              animationDuration: `${Math.random() * 5 + 2}s`,
              animationIterationCount: 'infinite'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default NotFound; 